<template>
  <div>
    <h2 class="th-title">{{title}}</h2>
    <div class="th-content-static">
      <p style="margin-bottom: 12px!important" class="italic">{{title}} ini berlaku efektif mulai {{effectiveDate}}.</p>
      <div class="th-paragraph">
        <p>
          Kami dari {{provider}} menghormati privasi Anda dan ingin agar Anda memahami cara kami mengumpulkan, menggunakan, dan membagikan data tentang Anda. Kebijakan Privasi ini mencakup praktik pengumpulan data kami dan menjelaskan hak Anda untuk mengakses, memperbaiki, atau membatasi penggunaan kami terhadap data pribadi Anda.
        </p>
      </div>
      <p><b>Dengan menggunakan Layanan, Anda menyetujui ketentuan {{title}} ini.</b> Anda sebaiknya tidak menggunakan Layanan jika Anda tidak menyetujui {{title}} ini atau perjanjian lainnya yang mengatur penggunaan Layanan oleh Anda.</p>
      <br />
      <p>{{title}} ini mencakup hal-hal sebagai berikut:</p>
      <ol style="list-style-type: upper-alpha;">
        <li v-for="(content) in tableOfContents" :key="content.key">{{content.title}}</li>
      </ol>
      <br />
      <ol>
        <li>
          Data Apa Yang Kami Dapatkan
          <div class="my-3">
            <div class="th-card th-bg-saturated p-3">
              Kami mengumpulkan data tertentu dari Anda secara langsung, seperti informasi yang Anda masukkan sendiri, data tentang penggunaan konten Anda, dan data dari platform pihak ketiga yang Anda hubungkan ke {{provider}}. Kami juga mengumpulkan sebagian data secara otomatis, seperti informasi tentang perangkat Anda dan dengan bagian apa dari Layanan kami Anda berinteraksi atau menghabiskan waktu saat menggunakannya.
            </div>

            <ul>
              <li>
                Data Akun dan Profil
                <div class="th-paragraph">
                  Untuk dapat menggunakan beberapa fitur tertentu (seperti mengakses konten), Anda perlu membuat akun pengguna. Saat Anda membuat atau memperbarui akun, kami akan mengumpulkan dan menyimpan data yang Anda berikan, seperti alamat email, kata sandi, nomor telepon, pekerjaan, gender, usia, tanggal lahir, foto profil, dan pengaturan akun, serta akan memberi Anda nomor pengidentifikasi unik.
                </div>
              </li>
              <li>
                Data Tentang Akun Anda di Layanan Lainnya
                <div class="th-paragraph">
                  Kami dapat memperoleh informasi tertentu melalui akun media sosial atau online Anda lainnya jika akun tersebut terhubung ke akun {{provider}} Anda. JIka Anda login ke {{provider}} melalui Facebook atau Google Mail atau layanan pihak ketiga lainnya, kami meminta izin Anda untuk mengakses informasi tertentu tentang akun lainnya tersebut. Misalnya, <b>bergantung pada platform atau layanan</b>, kami dapat mengumpulkan nama, profil, foto, nomor ID akun, alamat email login, lokasi, lokasi fisik, atau akses perangkat Anda, jenis kelamin, ulang tahun, dan daftar teman atau kontak.
                </div>
              </li>
              <li>
                Data Penggunaan
                <div class="th-paragraph">
                  Statistik penggunaan tentang interaksi Anda dengan Layanan, termasuk konten yang diakses, waktu yang dihabiskan di halaman atau Layanan, halaman yang dikunjungi, fitur yang digunakan, permintaan pencarian Anda, data klik, tanggal dan waktu, pemberi referensi, dan data lain mengenai penggunaan Layanan oleh Anda
                </div>
              </li>
            </ul>
          </div>
        </li>
        <li>
          Cara Kami Mendapatkan Data Tentang Anda
          <div class="mt-3">
            <div class="th-card th-bg-saturated p-3">
              Kami menggunakan alat seperti cookie dan teknologi pelacakan serupa lainnya untuk mengumpulkan data yang tercantum di atas. Beberapa alat ini menawarkan kepada Anda kemampuan untuk memilih menolak pengumpulan data.
            </div>

            <div class="th-paragraph">
              Kami menggunakan cookie, yang merupakan file teks kecil yang disimpan oleh browser untuk mengumpulkan, menyimpan, dan membagikan data tentang aktivitas Anda di seluruh situs web, termasuk di {{provider}}. Cookie juga memungkinkan kami untuk mengingat hal-hal seputar kunjungan Anda ke {{provider}}, seperti bahasa pilihan Anda, serta untuk membuat situs lebih mudah digunakan. Untuk mempelajari lebih lanjut tentang cookie, kunjungi <a href="https://cookiepedia.co.uk/all-about-cookies">https://cookiepedia.co.uk/all-about-cookies</a>.
            </div>

            <div class="th-paragraph">
              {{provider}} menggunakan jenis Alat Pengumpulan Data berikut untuk tujuan yang diuraikan:
              <ul>
                <li><span style="text-decoration: underline;">Sangat Diperlukan</span>: Alat Pengumpulan Data ini memungkinkan Anda mengakses situs, menyediakan fungsionalitas dasar (seperti login atau mengakses konten), melindungi situs, melindungi dari login yang menipu, serta mendeteksi dan mencegah penyalahgunaan maupun penggunaan akun yang tidak sah. Ini diperlukan agar Layanan dapat berfungsi dengan benar, jadi jika Anda menonaktifkannya, sebagian dari situs akan mengalami masalah atau tidak tersedia.</li>
                <li><span style="text-decoration: underline;">Fungsional</span>: Alat Pengumpulan Data ini akan mengingat data mengenai browser dan preferensi Anda, menyediakan fungsionalitas situs tambahan, mengkustomisasi konten agar lebih relevan dengan Anda, serta mengingat pengaturan yang memengaruhi tampilan dan perilaku Layanan (seperti pilihan bahasa atau tingkat volume untuk pemutaran video).</li>
                <li><span style="text-decoration: underline;">Kinerja</span>: Alat Pengumpulan Data ini membantu mengukur dan meningkatkan Layanan dengan menyediakan data penggunaan dan kinerja, jumlah kunjungan, sumber lalu lintas, atau tempat aplikasi diunduh. Alat ini dapat membantu kami menguji berbagai versi {{provider}} untuk melihat fitur atau konten mana yang lebih disukai pengguna, serta menentukan pesan email mana yang dibuka.</li>
                <li><span style="text-decoration: underline;">Media Sosial</span>: Alat Pengumpulan Data ini memungkinkan fungsionalitas media sosial, seperti berbagi konten dengan teman dan jaringan</li>
              </ul>
            </div>

            <div class="th-paragraph">
              Anda dapat mengatur browser web untuk mengingatkan Anda tentang upaya menempatkan cookie di komputer Anda, membatasi jenis cookie yang Anda izinkan, atau menolak cookie sama sekali. Jika Anda melakukannya, Anda mungkin tidak dapat menggunakan beberapa atau semua fitur Layanan, dan pengalaman Anda mungkin berbeda atau kurang fungsional.
            </div>
          </div>
        </li>
        <li>
          Untuk Apa Data Anda Digunakan

          <div class="mt-3">
            <div class="th-card th-bg-saturated p-3">
              Kami menggunakan data Anda untuk melakukan hal-hal seperti menyediakan Layanan kami, berkomunikasi dengan Anda, memecahkan masalah, melindungi dari penipuan dan penyalahgunaan, meningkatkan mutu dan memperbarui Layanan kami, menganalisis cara orang menggunakan Layanan kami, dan sebagaimana disyaratkan oleh hukum atau diperlukan untuk keamanan dan integritas.
            </div>
            <div class="th-paragraph">
              Kami menggunakan data yang kami kumpulkan melalui penggunaan Layanan oleh Anda untuk:
              <ul>
                <li>
                  Menyediakan dan mengelola Layanan, termasuk untuk memfasilitasi partisipasi dalam konten edukasi, menerbitkan sertifikat penyelesaian, menampilkan konten yang dikustomisasi, serta memfasilitasi komunikasi dengan pengguna lainnya;
                </li>
                <li>
                  Memproses permintaan dan pesanan Anda untuk konten edukasi, produk, layanan spesifik, informasi, atau fitur;
                </li>
                <li>
                  Berkomunikasi dengan Anda tentang akun Anda dengan cara:
                  <ul>
                    <li>Menanggapi pertanyaan dan kekhawatiran Anda;</li>
                    <li>Mengirimi Anda pesan dan informasi administratif, termasuk pesan dari instruktur, peserta, dan asisten pengajar, pemberitahuan tentang perubahan pada Layanan kami, dan pembaruan pada perjanjian kami;</li>
                    <li>Mengirimi Anda informasi, seperti melalui email maupun pesan teks, tentang kemajuan Anda dalam kursus dan konten terkait, layanan baru, fitur baru, promosi, buletin, dan konten lainnya (yang Anda dapat tolak kapan pun);</li>
                  </ul>
                </li>
                <li>Mengelola akun dan preferensi akun Anda;</li>
                <li>Memfasilitasi fungsi teknis Layanan, termasuk pemecahan masalah dan penyelesaian masalah, pengamanan Layanan, serta pencegahan penipuan dan penyalahgunaan;</li>
                <li>Meminta masukan dari pengguna;</li>
                <li>Memasarkan produk, layanan, survei, dan promosi;</li>
                <li>Mempelajari selengkapnya tentang Anda dengan menautkan data Anda ke data tambahan melalui penyedia data pihak ketiga dan/atau menganalisis data dengan bantuan penyedia layanan analisis;</li>
                <li>Meningkatkan mutu Layanan kami serta mengembangkan produk, layanan, dan fitur baru;
                </li>
                <li>Menganalisis tren dan trafik, melacak pembelian, serta melacak data penggunaan;</li>
                <li>Sebagaimana disyaratkan atau diizinkan oleh hukum; atau</li>
                <li>Sebagaimana kami, atas kebijakan kami semata, dengan cara lain menetapkan bahwa kami perlu memastikan keamanan atau integritas pengguna, karyawan kami, pihak ketiga, publik, atau Layanan kami.</li>
              </ul>
            </div>
          </div>
        </li>
        <li>
          Keamanan

          <div class="mt-3">
            <div class="th-card th-bg-saturated p-3">
              Kami menggunakan pengamanan yang semestinya berdasarkan pada jenis dan sensitivitas data yang disimpan. Terkait sistem yang diaktifkan dengan internet, selalu ada risiko akses tanpa izin sehingga penting untuk melindungi kata sandi Anda dan menghubungi kami jika Anda mencuriagai adanya akses tanpa izin ke akun Anda.
            </div>

            <div class="th-paragraph">
              {{provider}} mengambil tindakan yang semestinya untuk melindungi dari akses tanpa izin, pengubahan, pengungkapan, atau pemusnahan data pribadi Anda yang kami kumpulkan dan simpan. Tindakan ini bervariasi berdasarkan pada jenis dan sensitivitas data. Meski demikian, sayangnya tak ada sistem yang 100% aman sehingga kami tidak dapat menjamin bahwa komunikasi antara Anda dan {{provider}}, Layanan, atau informasi apa pun yang diberikan kepada kami sehubungan dengan data yang kami kumpulkan melalui Layanan akan bebas dari akses tanpa izin oleh pihak ketiga. Sandi Anda merupakan bagian penting dari sistem keamanan Anda, dan Anda bertanggung jawab untuk melindunginya. Anda sebaiknya tidak membagikan sandi kepada pihak ketiga mana pun, dan jika Anda meyakini bahwa sandi atau akun Anda telah dibobol, Anda harus segera menggantinya dan menghubungi Tim dengan kekhawatiran apa pun.
            </div>
          </div>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: 'Kebijakan Privasi',
      tableOfContents: [
        {
          key: 'Data',
          title: 'Data Apa Yang Kami Dapatkan',
        },
        {
          key: 'Cara',
          title: 'Cara Kami Mendapatkan Data Tentang Anda',
        },
        {
          key: 'Tujuan',
          title: 'Untuk Apa Data Anda Digunakan',
        },
        {
          key: 'Keamanan',
          title: 'Keamanan',
        },
      ],
      effectiveDate: '29 April 2021',
      provider: process.env.VUE_APP_TITLE,
    }
  },
}
</script>

<style lang="scss">
</style>
